import styled from "styled-components"

export const Container = styled.div`
  height: auto;
  min-height: 100%;
  box-sizing: border-box;
  padding: 2rem;
  display: grid;
  gap: 2rem;
  place-content: space-between stretch;
  user-select: text;
`

export const A = styled.a`
  text-decoration: none;
  color: #fff;
`
